import TemplateView from '../../TemplateView'
import CsvExportButton from './CsvExportButton'
import {connect} from '../../redux/utils'
import {getViewMode} from '../common/selectors'
import {TaskManagementViewMode} from '../constants'

class TaskListExportPanel extends TemplateView {
    constructor() {
        super()
        this.state = {
            hidden: false,
        }
        this.onStatePropertyChanged('hidden', (value) => this.getEl().toggleClass('hidden', value))
    }

    templateHtml() {
        return "<div class='csvExportPanel'>" +
               "    <div class='csvExport container'/>" +
               "    <div class='separator'/>" +
               "</div>"
    }

    afterRender() {
        new CsvExportButton().init(this.find(".csvExport"))
    }
}

export default connect(
    (state) => ({
        hidden: getViewMode(state) !== TaskManagementViewMode.TABLE,
    }))(TaskListExportPanel)


// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/TaskListExportPanel.js